"use client";
// 專題下半部 相關推薦 內容
import { useTranslation } from "react-i18next";

import ProjectRelatedNews from "./ProjectRelatedNews"; // 專題關聯新聞
import ProjectPodcast from "./ProjectPodcast"; // 專題推薦 podcast
import ProjectYoutube from "./ProjectYoutube"; // 專題相關 youtube
import ProjectEvent from "./ProjectEvent"; // 專題相關 活動
import ProjectKeyword from "./ProjectKeyword"; // 專題 焦點關鍵字
import ProjectBack from "./ProjectBack"; // 返回列表
import ExtendNews from "../news/ExtendNews"; // 可能想知道的新聞

const ProjectClientBottom = ({ project, locale }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* 關聯新聞 */}
      {project?.news.length > 0 && (
        <ProjectRelatedNews newsList={project?.news} t={t} />
      )}

      {/* 推薦 podcast */}
      {project?.podcasts.length > 0 && (
        <ProjectPodcast t={t} podcasts={project?.podcasts} />
      )}

      {/* 相關 youtube 影片 */}
      {project?.youtubes.length > 0 && (
        <ProjectYoutube youtubeList={project?.youtubes} />
      )}

      {/* 專題相關活動 */}
      {project?.activities.length > 0 && (
        <ProjectEvent t={t} events={project?.activities} locale={locale} />
      )}

      {/* 焦點關鍵字 */}
      {project?.tags.length > 0 && <ProjectKeyword tags={project?.tags} />}

      {/* 返回列表 */}
      <ProjectBack />

      {/* 你可能想知道新聞 */}
      <ExtendNews locale={locale} newsId={3000} />
    </>
  );
};

export default ProjectClientBottom;
